import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-6 py-2 bg-indigo-lighten-2 d-flex justify-space-between" }
const _hoisted_2 = { class: "ma-4" }
const _hoisted_3 = { class: "ma-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "ma-3" }
const _hoisted_6 = { class: "ma-3 d-flex justify-space-between" }

import {ref, watch, onMounted} from 'vue'
import {GameDisplay} from "@/utils";
import {ApiMap} from "@/api/type";
import TeamTile from "@/components/board/TeamTile.vue";
import {game} from "@/api";
import {useApi} from "@/api/handler";


export default /*@__PURE__*/_defineComponent({
  __name: 'BoardStatus',
  props: {
    data: {}
  },
  emits: ['update'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const emits = __emit
const showOverlay = ref<boolean>(false)
const nextRoundConfirm = ref(false)

const handleNextStage = () => {
  // 在棋盘赛结算阶段（phase=3），点击"下一阶段"等同于"进入下一轮"，弹窗二次确认
  if (GameStatus.value && GameStatus.value.stage === 1 && GameStatus.value.chessPhase === 3) {
    nextRoundConfirm.value = true
  } else {
    // 其他阶段：保持原逻辑，刷新游戏状态
    emits('update')
  }
}

const doNextRound = () => {
  if (!GameStatus.value) return
  useApi({
    api: game.NextRound(GameStatus.value.id),
    onSuccess: () => {
      nextRoundConfirm.value = false
      emits('update')
    },
    tip: '已进入下一轮'
  })
}

onMounted(() => {
  GameStatus.value = props.data
})

watch(() => props.data, newVal => {
  GameStatus.value = newVal
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (GameStatus.value)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-h6" }, "游戏状态", -1)),
              _createVNode(_component_v_btn, {
                class: "mr-2",
                variant: "outlined",
                color: "white",
                onClick: handleNextStage
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("下一阶段")
                ])),
                _: 1,
                __: [6]
              })
            ]),
            _createVNode(_component_v_dialog, {
              modelValue: nextRoundConfirm.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nextRoundConfirm).value = $event)),
              "max-width": "420"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-h6" }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("确认进入下一轮？")
                      ])),
                      _: 1,
                      __: [8]
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode(" 进入下一轮后，本轮所有事件将不可撤销。"),
                        _createElementVNode("br", null, null, -1),
                        _createElementVNode("span", { class: "text-caption text-grey" }, "请确认所有结算无误后再继续。", -1)
                      ])),
                      _: 1,
                      __: [9]
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "grey",
                          variant: "text",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (nextRoundConfirm.value = false))
                        }, {
                          default: _withCtx(() => _cache[10] || (_cache[10] = [
                            _createTextVNode("取消")
                          ])),
                          _: 1,
                          __: [10]
                        }),
                        _createVNode(_component_v_btn, {
                          color: "warning",
                          variant: "elevated",
                          onClick: doNextRound
                        }, {
                          default: _withCtx(() => _cache[11] || (_cache[11] = [
                            _createTextVNode("确认进入")
                          ])),
                          _: 1,
                          __: [11]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "font-weight-bold" }, "游戏赛段：", -1)),
                _createVNode(_component_v_chip, {
                  color: _unref(GameDisplay).colorTrans('stage', GameStatus.value.stage)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(GameDisplay).displayTrans('stage',GameStatus.value.stage)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              (GameStatus.value.stage === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "font-weight-bold" }, "棋盘赛轮次：", -1)),
                      _createTextVNode("第 " + _toDisplayString(GameStatus.value.chessRound) + " 轮 ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "font-weight-bold" }, "棋盘阶段：", -1)),
                        _createVNode(_component_v_chip, {
                          color: _unref(GameDisplay).colorTrans('chessPhase', GameStatus.value.chessPhase)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(GameDisplay).displayTrans('chessPhase', GameStatus.value.chessPhase)), 1)
                          ]),
                          _: 1
                        }, 8, ["color"])
                      ]),
                      (GameStatus.value.chessPhase === 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            height: "30",
                            text: "设置",
                            variant: "outlined",
                            color: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (showOverlay.value = true))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(TeamTile, {
          "team-ids": [1, 2, 3, 4, 5, 6, 7],
          "game-id": GameStatus.value.id,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showOverlay.value = false)),
          onUpdate: _cache[4] || (_cache[4] = ($event: any) => (emits('update')))
        }, null, 8, ["game-id"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})